import * as yup from 'yup';

export const citizenshipSchemaObject = {
  // matricola: yup.string().required('Campo obbligatorio'),
  surname: yup.string().required('Campo obbligatorio'),
  name: yup.string().required('Campo obbligatorio'),
};

const citizenshipSchema = yup.object().shape(citizenshipSchemaObject);

export default citizenshipSchema;
